import React, { Component } from 'react'
import { connect } from 'react-redux'

import CssBaseline from '@material-ui/core/CssBaseline'
import JssProvider from 'react-jss/lib/JssProvider'
import { createGenerateClassName } from '@material-ui/core/styles'

import BkFlowContent from './structure/BkFlowContent'
import BkFlowError from '../components/elements/BkFlowError'
import BkFlowLoader from '../components/elements/BkFlowLoader'
import BkFlowSessionModal from '../components/structure/session/BkFlowSessionModal'

// import getCookie from '../utilities/session/getCookie'
import eraseCookie from '../utilities/session/removeCookie'
import OneTrustWrapper from '../utilities/analytics/OneTrustWrapper'

import yn from 'yn'
import _ from 'lodash'

const generateClassName = createGenerateClassName({
	dangerouslyUseGlobalCSS: true,
});

class App extends Component {
	constructor(props) {
		super(props)
		const baseTimeOut = process.env.REACT_APP_COMPONENT_SESSION_TIMEOUT_DURATION || 900

		this.sessionTimeoutMs = Number(baseTimeOut) * 1000
		this.mountedAt = Date.now()
		this.checkSessionExpiry = this.checkSessionExpiry.bind(this)

		this.state = {
			sessionExpired: false
		}
	}

	// Wall-clock check: interval ticks are throttled/suspended in hidden tabs,
	// so elapsed time is measured with Date.now() and re-checked on refocus
	checkSessionExpiry() {
		if (
			!this.state.sessionExpired &&
			Date.now() - this.mountedAt >= this.sessionTimeoutMs
		) {
			this.setState({ sessionExpired: true })
			clearInterval(this.intervalId)
		}
	}

  componentDidMount() {
	  // Import Query string & Parse URL
	  const queryString = require('query-string')
	  const urlQuery = queryString.parse(window.location.search)
	  const queryParams = window.localStorage.getItem('flowCurrentQuery')

	  const { hotelCode } = urlQuery;

	  if (hotelCode === "61890") {
		  const newUrlQuery = queryString.parse(window.location.search);
		  newUrlQuery.hotelCode = "B5C1";

		  window.history.pushState( {} , '', '/book?' + queryString.stringify(newUrlQuery))
		  window.location.reload();
	  }

	  // const queryParams = getCookie('flowCurrentQuery')
	  if (queryParams) {
		  window.history.pushState( {} , '', '/book?' + queryParams)

		  setTimeout(function() {
			  window.localStorage.removeItem('flowCurrentQuery')
		  	eraseCookie('flowCurrentQuery')
		  }, 1000)
	  }

	  let appMain = document.getElementById('bk-flow__main')

	  // Set brand-level class for theme styles
	  if (
	  	urlQuery.theme &&
		  urlQuery.theme !== '' &&
		  urlQuery.theme !== 'null'
	  ) {
		  document.body.classList.add(urlQuery.theme)
	  }

	  // Set sticky-nav class based on ENV boolean
	  if (yn(process.env.REACT_APP_COMPONENT_FIXED_NAVIGATION)) {
		  appMain.classList.add('sticky-nav')
	  }

	  if (
	  	yn(process.env.REACT_APP_COMPONENT_ENABLE_PROFILE_SERVICES) &&
		  yn(process.env.REACT_APP_COMPONENT_LANGUAGE_UTILITY_BAR)
	  ) {
		  appMain.classList.add('inc-utility')
	  }

	  this.intervalId = setInterval(this.checkSessionExpiry, 1000)
	  document.addEventListener('visibilitychange', this.checkSessionExpiry)
	  window.addEventListener('focus', this.checkSessionExpiry)
  }

	componentWillUnmount(){
		clearInterval(this.intervalId);
		document.removeEventListener('visibilitychange', this.checkSessionExpiry)
		window.removeEventListener('focus', this.checkSessionExpiry)
	}

	render() {
		const {
			configData,
			configLoading,
			configError,
			availabilityData
		} = this.props

		const appMain = document.getElementById('bk-flow__main')
		const hasMaintenanceMessage = _.get(availabilityData, 'availability[0][0].viewExtensions.bookingMessages')

		if (hasMaintenanceMessage) {
			appMain.classList.add('inc-maintenance-banner')
		}

		return (
			<JssProvider generateClassName={ generateClassName }>
				<OneTrustWrapper>
					<div
						id="bk-flow__main"
						className="bk-flow__main"
					>
						<CssBaseline />

						{ configLoading ?
							<BkFlowLoader />
						: configError ?
							<BkFlowError
								configData={ configData}
								availabilityData={ availabilityData }
								requestError={ configError }
							/>
						:
							<BkFlowContent />
						}
						{yn(process.env.REACT_APP_COMPONENT_ENABLE_SESSION_TIMEOUT) &&
						this.state.sessionExpired &&
							<BkFlowSessionModal configData={configData} />
						}
					</div>
				</OneTrustWrapper>
			</JssProvider>
		)
	}
}

const mapStateToProps = state => ({
	configData: state.configData.configuration,
	configLoading: state.configData.loading,
	configError: state.configData.error,
	availabilityData: state.availabilityData
})

export default connect(mapStateToProps, null)(App)


// WEBPACK FOOTER //
// ./src/containers/App.js